/**
 * Technologies Section Transformers
 * Aggregates all technologies-related transformers and provides section-level utilities
 */

import { transformServerIp } from './serverIpTransformer';
import { transformTechnologies } from './technologiesTransformer';
import { transformAnalyticsTechnologies } from './analyticsTransformer';

// Re-export individual transformers
export { transformServerIp } from './serverIpTransformer';
export { transformTechnologies } from './technologiesTransformer';
export { transformAnalyticsTechnologies } from './analyticsTransformer';

/**
 * Transforms all technologies section criteria from WooRank API response
 * @param {Object} apiData - The SEO audit data object (already response.data from API)
 * @returns {Object} - Transformed technologies section data with aggregated counts
 */
export const transformTechnologiesSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const serverIp = transformServerIp(criteria?.ip_information);
  const technologies = transformTechnologies(criteria?.technologies);
  const analytics = transformAnalyticsTechnologies(criteria?.analytics_technologies);

  const allResults = [serverIp, technologies, analytics];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    serverIp,
    technologies,
    analytics,
  };
};

export default transformTechnologiesSection;


